import { FieldInputProps } from 'react-final-form'
import { Visibility, VisibilityOff } from '@material-ui/icons'

/**
 * @description check is password is visible
 */
export const isVisible = (input: FieldInputProps<string, HTMLElement>): boolean => {
  if (typeof input.value === 'object') {
    const object = input.value as {
      visible: boolean
      value: string
    }
    if (object.visible) {
      return true
    }
  }
  return false
}

/**
 * @description return text or password
 */
export const renderType = (input: FieldInputProps<string, HTMLElement>): string => {
  if (isVisible(input)) {
    return 'text'
  }
  return 'password'
}

/**
 * @description if is an object return input.value.value or input.value
 */
export const renderValue = (input: FieldInputProps<string, HTMLElement>): string => {
  if (typeof input.value === 'object') {
    const object = input.value as {
      visible: boolean
      value: string
    }
    return object.value
  }
  return input.value
}

/**
 * @description render eyes icon
 */
export const renderIcon = (input: FieldInputProps<string, HTMLElement>): React.ReactElement => {
  if (isVisible(input)) {
    return <Visibility />
  }
  return <VisibilityOff />
}

/**
 * @description check if value is an object
 */
export const isAnObject = (input: FieldInputProps<string, HTMLElement>): boolean => {
  if (typeof input.value === 'object') {
    return true
  }
  return false
}
